import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useState } from 'react';
import { ActionFinishPanel } from './panels';

interface Props {
  id: string;
  title: string;
}

export function ActionDetailsFinishButton({ id, title }: Props) {
  const { t } = useTranslation('action');

  const [panelIsOpen, setPanelIsOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        onClick={() => setPanelIsOpen(true)}
        variant='contained'
        data-testid='change-status-button'
      >
        {t('view.details.buttons.markAsDone')}
      </Button>
      <ActionFinishPanel
        actionId={id}
        actionTitle={title}
        isOpen={panelIsOpen}
        onClose={() => setPanelIsOpen(false)}
      />
    </>
  );
}
